module.exports = __webpack_public_path__ + "static/img/complete.00df8e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/tools/complete.png
// module id = hyfh
// module chunks = 0